import { getStateSliceFor, getProductFor } from 'redux/Studio';
import { pdpReducerKey } from './reducer';

import { createSelector } from 'reselect';

// =========
// SELECTORS
// =========
const extractDataFrom = state => getStateSliceFor({ state, reducerKey: pdpReducerKey });
export const getSelectedProduct = state => extractDataFrom(state).selectedProduct;
export const getAlternativeProduct = state => extractDataFrom(state).altProduct;
export const getCurrentQuantity = state => extractDataFrom(state).currentQuantity;
export const getCurrentQuantityMultiple = createSelector(
  [getSelectedProduct],
  (selectedProduct) => selectedProduct.getQuantityMultiple()
);
export const getAlternatives = state => extractDataFrom(state).alternatives;
export const getDisplayedAlternatives = state => extractDataFrom(state).displayedAlternatives;
export const getFiltersApplied = state => extractDataFrom(state).filtersApplied;
export const getFilterOptions = state => extractDataFrom(state).filterOptions;
export const getFilterValues = state => extractDataFrom(state).filterValues;
export const getColors = state => getFilterOptions(state).color;
export const getMaterials = state => getFilterOptions(state).material;

export const getVariantLoadStatus = state => extractDataFrom(state).variantsLoading;
export const getVariantProducts = createSelector(
  state => extractDataFrom(state).displayedVariants,
  state => state, // should be fine, as the default memoizer doesn't do deep equality
  (variantIds, state) => variantIds.map(productId => getProductFor({ productId, state }))
);

export const getVariantsByAttribute = state => extractDataFrom(state).attributeVariants;
